import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    getImagePathWithTheme, getImagePathWithThemeSvg, getItem,
    getNoteFirstHtmlForLeftCard, isFileElement,
    isFileVideoElement, isLiveVideoElement,
    isNoteElement,
    isPdfFileElement
} from "../../utils";
import {Button, ConfigProvider, Dropdown, Flex, Input, Modal, Tree, message} from "antd";
const {DirectoryTree} = Tree;
import Icon, {LoadingOutlined} from "@ant-design/icons";
import {FieldDataNode} from "rc-tree/lib/interface";
import {TreeProps} from "antd/es/tree";
import { t } from "i18next";
import {isElementInContent,getElementColor, getElementTitle,getElementIcon } from "@/elementUtility";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {EVENT_OPEN_LIBRARY_ITEM, EVENT_REFRESH_CONTENT_BOOKMARK_, EVENT_TEST_ONDRAG_NOTE} from "@/Const";
import {IconAddToFavor, IconDelete, IconRemoveFavor, IconRemoveFavorNew, IconRename} from "@/Icon";
import {
    isFrameElement,
    isImageElement, isMindmapElement,
    isProjectLinkElement,
    isStickyNotesElement
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {resetAttributes} from "@/components/EditorV2/extension-youtube/dist/packages/core/src/commands";
import {getNoteJsonDoc, getProjectByIds} from "@model/note";
import { getCardByIds } from "@model/card";
import { globalMapAnnoCount } from "./TreeListContentContent";
import {mutateElement} from "../../../@excalidraw/packages/excalidraw";
import global from "@/global";
import {findNodeLevel, loop, loopAllNode, loopRemove} from "@/TreeUtils";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";

type DataNode = FieldDataNode<{
    key:string;
    title?:string;
    editValue?:string;
    isEditable?:boolean;
    isFolder:boolean;
    drawJson:any;
    children?:any;
    icon:any;
    isSelected?:boolean;
    isHover?:boolean;
}>

let mRootDiv:any = null;//drag的folder....
let mIsDefaultDragOk = false;
let mSelectFolder:any = null;

const TreeListContentBookmark = forwardRef((props:{style:any,onAction:any,height:any},ref)=>{
    useImperativeHandle(ref,()=>({
        onRefreshElement:onRefreshElement,
        onRefreshSingleElement:onRefreshSingleElement,
        onClearSelected:onClearSelected
    }))

    const [expandKeys,setExpandKeys] = useState([]);
    const [treeSelectedKeys,setTreeSelectedKeys] = useState([]);
    const [arrayTreeData,setArrayTreeData] = useState([]);
    const [hoveredKey,setHoveredKey] = useState('');
    const [isPresentMode,setIsPresentMode] = useState(false);

    const mArrayProjectsCache = useRef<any>([]);//当前projectlink的项目缓存.
    const mArrayElementsCache = useRef(null);//上一次的所有元素缓存.
    const mArrayLibrarysCache = useRef<any>([]);//库中的一些数据，有些数据并没有存在element.customData.generationData中。。。。
    const mIsDragging = useRef(false);
    const mDivLeftMenuContainer = useRef(null);

    useEffect(() => {
        recvMessage(EVENT_REFRESH_CONTENT_BOOKMARK_,(msg,data)=>{
            onRefreshElement(data.data.elements);
        })

        return ()=>{
            unSubscribe(EVENT_REFRESH_CONTENT_BOOKMARK_);
        }
    }, [arrayTreeData]);

    const onRefreshElement = async (arrayElements:any)=>{
        let arrayBookmarks = arrayElements.filter(p=>p.extra?.favor == 1);
        //排序.
        sortElement(arrayBookmarks);

        //取project项目，用于名称的显示
        const arrayProjectLinksElements = arrayBookmarks.filter(p=>isProjectLinkElement(p));
        const arrayProjectIds:any = [];
        for (let i=0;i<arrayProjectLinksElements.length;i++){
            const projectElement = arrayProjectLinksElements[i];
            if (projectElement?.customData?.projectId == PROJECT_ID)continue;
            // if (!mArrayProjectsCache.current.some(p=>p?.id == projectElement?.customData?.projectId))
            {
                arrayProjectIds.push(projectElement?.customData?.projectId);
            }
        }
        if (PROJECT_ID){
            arrayProjectIds.push(PROJECT_ID);
        }
        let arrayProjects:any = await getProjectByIds(arrayProjectIds);
        arrayProjects = arrayProjects.filter(p=>p != undefined && p?.isDeleted != 1);
        //过滤--项目必须存在的
        arrayBookmarks = arrayBookmarks.filter((p)=>{
            if (isProjectLinkElement(p)){
                return arrayProjects.some(project=>project.id == p.customData?.projectId);
            }
            return true;
        })
        //查项目doc
        for (let i=0;i<arrayProjects.length;i++){
            const project = arrayProjects[i];
            if (project){
                project.doc = await getNoteJsonDoc(project.id);
            }
        }
        //删除本项目的.
        // const nIndex = mArrayProjectsCache.current.findIndex(p=>p?.id == PROJECT_ID);
        // if (nIndex != -1){
        //     mArrayProjectsCache.current.splice(nIndex,1);
        // }
        mArrayProjectsCache.current.length = 0;
        mArrayProjectsCache.current.push(...arrayProjects);

        //取库中的一些数据，用于名称显示,数量.
        const arrayLibrarysElments = arrayBookmarks.filter(p=>isLiveVideoElement(p) || isFileVideoElement(p) || isLiveVideoElement(p) || isPdfFileElement(p));
        const arrayLibraryIds:any = [];
        for (let i=0;i<arrayLibrarysElments.length;i++){
            const libraryElements = arrayLibrarysElments[i];
            if (!mArrayLibrarysCache.current.some(p=>p.id == libraryElements?.customData?.generationData?.id))
            {
                arrayLibraryIds.push(libraryElements?.customData?.generationData?.id);
            }
        }
        const arrayLibrarys:any = await getCardByIds(arrayLibraryIds);
        mArrayLibrarysCache.current.push(...arrayLibrarys);

        let arrayData:any = [];
        for (let i=0;i<arrayBookmarks.length;i++){
            const element = arrayBookmarks[i];
            let node = elementToNode(element);
            arrayData.push(node);
        }
        setArrayTreeData(arrayData);
    }

    const onRefreshSingleElement = (element)=>{

    }

    /**
     * 选择标题
     */
    const onClearSelected = ()=>{
        setTreeSelectedKeys([]);
    }

    /**
     * 排序
     * @param arrayElements
     */
    const sortElement = (arrayElements)=>{
        //按收藏时间排序.
        arrayElements.sort((a,b)=>{
            return b.extra.favirateTime - a.extra.favirateTime;
        })

        //按sort排序
        arrayElements.sort((a,b)=>{
            if (a.extra.sort && b.extra.sort){
                return a.extra.sort - b.extra.sort;
            }
            return 0;
        })
    }


    /**
     * element-->node
     * @param element
     */
    const elementToNode = (element:any)=>{
        const node = {
            key:element.id,
            title:element.name,
            editValue:element.name,
            isEditable:false,
            isFolder:false,
            element:element,
        }
        node.title = node.editValue = getRealElementTitle(element);
        node.color = getElementColor(element);
        if (globalMapAnnoCount[node.key]){
            node.annoCount = globalMapAnnoCount[node.key];
        }
        if (isFileVideoElement(element) || isLiveVideoElement(element)){
            const library = mArrayLibrarysCache.current.find(p=>p.customData?.generationData?.id);
            if (library){
                node.annoCount = library.videoAnn;
            }

        }
        return node;
    }

    /**
     * 实际的标题，有些element元素中并没有标题。这里还要额外处理...
     * @param element
     */
    const getRealElementTitle = (element:any)=>{
        let szTitle = '';
        if (isProjectLinkElement(element)){
            const project = mArrayProjectsCache.current.find(p=>p?.id == element?.customData?.projectId);
            if (element.customData?.boardId){
                if (project?.doc){
                    loopAllNode(project.doc.canvas,(item)=>{
                        if (!szTitle && item.key == element.customData?.boardId){
                            szTitle = item.title;
                        }
                    })
                }
            }else{
                szTitle = project?.name || t('Untitled');
            }
        }else if (isLiveVideoElement(element)){
            const library = mArrayLibrarysCache.current.find(p=>p?.id == element.customData?.generationData?.id);
            szTitle = library?.name || t('Untitled');
        }
        else{
            szTitle = getElementTitle(element);
        }
        return szTitle;
    }

    const onExpand:TreeProps["onExpand"]=((expandedKeys:any, expanded) => {
        setExpandKeys(expandedKeys);
    })

    /**
     * tree选择.....
     */
    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
        setTreeSelectedKeys(selectedKeys);
        props.onAction('zoomTo',{element:info.node.element})
    });

    const onDragStart = (info)=>{
        console.log('onDragStart');
        mIsDragging.current = true;
    }

    const isMouseInDiv = (event)=>{
        const x = event.clientX;
        const y = event.clientY;
        const rects = event.currentTarget.getClientRects();
        const rect = rects[0];


        // console.log('onDragOver:',`x:${x} y:${y}`,rect);
        return (x > rect.left && x<(rect.right - 11)  && y > rect.top && y<(rect.bottom - 11))
    }

    const onDragOver = (info) => {
        // console.log(info.node);
        mIsDefaultDragOk = false;

        if (mRootDiv != null) {
            mRootDiv.style.border = '0px';
        }
        mSelectFolder = null;


        if (info.node.isFolder) {
            //判断当前经过的点是否在这个区域内.
            // const x = info.event.clientX;
            // const y = info.event.clientY;
            // const rects = info.event.currentTarget.getClientRects();
            // const rect = rects[0];
            mRootDiv = info.event.currentTarget;

            // console.log('onDragOver:',`x:${x} y:${y}`,rect);
            if (isMouseInDiv(info.event)){
                mRootDiv.style.border = '1px solid #0085FF';
            }else{
                mRootDiv.style.border = '0px solid #0085FF';
            }
            mSelectFolder = mRootDiv;
        } else {
            //根据ID找到父级
            loop(arrayTreeData, info.node.key, ((node, i, data, parent) => {
                if (parent != undefined) {
                    var div = document.getElementById(parent.key);
                    if (div != undefined) {
                        mRootDiv = div.parentElement.parentElement.parentElement;
                        // mRootDiv.style.border = '1px solid #0085FF';
                    }
                }
            }))
        }
    }

    const onDragEnd = (info) => {
        mIsDragging.current = false;

        //// 这里执行到画布上的操作.
        if (global.g_isPresentMode) return;

        // mDivLeftMenuContainer.current.getBoundingClientRect().left +
        let mOffset = mDivLeftMenuContainer.current?.offsetWidth * 2;
        if (info.event.clientX > mOffset){
            // if (info.node.isFolder){
            //     message.error(t("ThisOperationIsNotSupported"))
            // }else{
            //     const dragData = {
            //         ...info.node,
            //         x: info.event.clientX,
            //         y: info.event.clientY,
            //         type:'board'
            //     }
            //
            //     postMessage(EVENT_TEST_ONDRAG_NOTE, dragData);
            // }
        }else{
            if (mRootDiv != null) {
                mRootDiv.style.border = '0px';
            }
            if (mSelectFolder != null && !mIsDefaultDragOk) {
                let szMoveKey = info.node.key;
                if (info.dragNode != undefined) {
                    szMoveKey = info.dragNode.key;
                }
                var arrayDivs = mSelectFolder.getElementsByClassName("custom-element");
                if (arrayDivs.length > 0) {
                    setTimeout(() => {
                        var szDestKey = arrayDivs[0].id;
                        var arrayNew = [...arrayTreeData];
                        loop(arrayNew,szDestKey,(item, i, data, parent)=>{
                            if (item.isFolder){
                                var newNode = loopRemove(arrayNew, szMoveKey);
                                if (newNode) {
                                    item.children.splice(0, 0, newNode);
                                    setArrayTreeData(arrayNew);
                                    // onExpandAndNavIfBoard(arrayNew,newNode);
                                }
                            }
                        })
                    }, 50);
                }
            }
        }

        //按这个顺序保存一遍
        const arrayDatas = [...arrayTreeData];
        for (let i=0;i<arrayDatas.length;i++){
            const element = arrayDatas[i].element;
            element.extra.sort = (i+1);
        }
        setArrayTreeData(arrayDatas);
    }

    const onDrop: TreeProps['onDrop'] = (info) => {
        console.log(info);
        if (mRootDiv != null) {
            mRootDiv.style.border = '0px';
        }
        var isDragOk = true;
        const dropKey = info.node.key;
        const dragKey = info.dragNode.key;
        const dropPos = info.node.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        //移到的节点的level
        const nDestLevel = findNodeLevel(arrayTreeData,dropKey)
        if (info.dragNode.isFolder &&  (nDestLevel > 1 || (info.node.isFolder && nDestLevel > 0))){
            message.error(t('MaximumFolder'));
            isDragOk = false;
            return;
        }

        const data = [...arrayTreeData];

        // Find dragObject
        let dragObj: DataNode;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        mIsDefaultDragOk = false;

        if (!info.dropToGap) {
            /// Drop on the content
            let nFolderPosition = -1;
            loop(data, dropKey, (item, i: number, data: DataNode[], parent?: DataNode) => {

                if (!item.children) {//不能移到画布下一级。。。。
                    //插入到当前下...
                    // for (let i=0;i<data.length;i++){
                    //     const favor = data[i];
                    //     if (favor.isFolder){
                    //         const nCurIndex = favor.children.findIndex(p=>p.id == item.id);
                    //         if (nCurIndex != -1){
                    //             //插入到这个位置
                    //             favor.children.splice(nCurIndex+1, 0, info.dragNode);
                    //             isDragOk = true;
                    //             break;
                    //         }
                    //     }
                    // }
                    if (parent){
                        const nCurIndex = parent?.children.findIndex(p=>p.key == item.key);
                        if (nCurIndex != undefined && nCurIndex != -1){
                            if (parent?.children){
                                parent.children.splice(nCurIndex+1,0,info.dragNode);
                                isDragOk = true;
                            }
                        }
                    }else {
                        //在根目录的画布自行交换.
                        const nCurIndex = data.findIndex(p => p.key == item.key);
                        if (nCurIndex != undefined && nCurIndex != -1) {
                            data.splice(nCurIndex + 1, 0, info.dragNode);
                            isDragOk = true;
                        }
                    }

                } else {
                    if (info.dragNode.isFolder && item.isFolder) {
                        isDragOk = true;
                        //添加到和item下面的下面一个位置.
                        // nFolderPosition = data.findIndex(p=>p.key == item.key);
                        item.children.unshift(dragObj);
                    } else {
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                    }
                }
            });
            // if (nFolderPosition != -1){
            //     //添加到和item平级的下面一个位置.
            //     data.splice(nFolderPosition+1,0,info.dragNode);
            // }
            if (isDragOk){
                mIsDefaultDragOk = true;
            }
        } else if (
            ((info.node as any).props.children || []).length > 0 && // Has children
            (info.node as any).props.expanded && // Is expanded
            dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, (item) => {
                if (item.children == null) {//不能移到画布下。。。。
                    isDragOk = false;
                } else {
                    if (info.dragNode.isFolder && item.isFolder) {
                        isDragOk = false;
                    } else {
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                        // in previous version, we use item.children.push(dragObj) to insert the
                        // item to the tail of the children
                    }
                }
            });
        } else {
            let ar: DataNode[] = [];
            let i: number;
            loop(data, dropKey, (_item, index, arr, parent) => {
                if ((info.dragNode.isFolder && (_item.isFolder || parent?.isFolder))) {
                    isDragOk = true;
                    //移动位置....
                    ar = arr;
                    i = index;
                    // if (isMouseInDiv(info.event)){
                    //     if (_item.isFolder){
                    //         ar = _item.children;
                    //     }
                    // }

                } else {
                    ar = arr;
                    i = index;
                    // if (isMouseInDiv(info.event)){
                    //     if (_item.isFolder){
                    //         ar = _item.children;
                    //     }
                    // }
                }
            });
            if (dropPosition === -1) {
                ar.splice(i!, 0, dragObj!);
            } else {
                ar.splice(i! + 1, 0, dragObj!);
            }
        }

        if (isDragOk) {
            // for (let i = 0; i < data.length; i++) {
            //     data[i].sort = i;
            // }
            setArrayTreeData(data);
        }

        if (arrayTreeData.length != data.length) {
            mIsDefaultDragOk = true;
        }
        // onDragEnd(info,isDragOk,menuData);
        mIsDragging.current = false;

        //展开父文件夹并转到这个画布，如果是画布的话.
        // onExpandAndNavIfBoard(data,info.dragNode);

        // if (props.onDragEnd){
        //     props.onDragEnd().then(res=>{
        //         window.globalRefreshList('embedProject_');
        //     });
        // }
    };

    const onTreeMouseEnter: TreeProps["onMouseEnter"] = (event) => {
        if (isPresentMode) return;
        setHoveredKey(event.node.key);
    }

    const onTreeMouseLeave: TreeProps["onMouseLeave"] = (event) => {
        setHoveredKey('')
    }

    const getMenus = (node:any) => {
        const menus = [
            getItem(t("RemoveFromBookmark"), 'removeFromBookmark', <IconRemoveFavorNew/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                const extra = node.element.extra;
                extra.favor = 0;
                mutateElement(node.element,{extra:extra});
                //刷新
                props.onAction('refreshElements')
            }),
        ];

        return menus;
    }

    return<>
        {
            arrayTreeData.length == 0 ? <div className={'default-font-size flex-center'} style={{...props.style, color:'var(--text-color-bab8b8)',margin:'12px 32px',textAlign:'center',lineHeight:'20px'}}>{t("AddBookmarksToQuickly")}</div>:
                <ConfigProvider
                    theme={{
                        components: {
                            Tree:{
                                colorPrimary: 'var(--primary-color)',
                                directoryNodeSelectedBg:isPresentMode?'#444444':'var(--select-background-color)',
                                indentSize:0,
                                borderRadius:0,
                                titleHeight:32,
                            }
                        }
                    }}
                >
                    <DirectoryTree
                        rootStyle={props.style}
                        className="tree-fuck-ant-left-align-info"
                        switcherIcon={<Icon component={() => <img className='img-10' style={{marginTop:'0px'}} src={getImagePathWithTheme('tree_icon')}/>}/>}
                        expandedKeys={expandKeys}
                        onExpand={onExpand}
                        height={props.height - 48}
                        onSelect={onSelect}
                        treeData={arrayTreeData}
                        selectedKeys={treeSelectedKeys}
                        onRightClick={(info)=>{
                            setTreeSelectedKeys([info.node.key as string])
                        }}
                        showIcon={false}
                        blockNode={true}
                        onMouseEnter={onTreeMouseEnter}
                        onMouseLeave={onTreeMouseLeave}
                        draggable={true}
                        onDragOver={onDragOver}
                        onDragStart={onDragStart}
                        onDragEnd={onDragEnd}
                        onDrop={onDrop}
                        titleRender={(nodeData:DataNode)=>{
                            if(nodeData.isEditable){
                                return(
                                    <div style={{display: "flex", width: "206px", alignItems: "center"}}>
                                <span className={'flex-center'}>
                                        {getElementIcon(nodeData.element, nodeData.color,true)}
                                    </span>

                                        <Input id={`txt-edit-${nodeData.key}`} className='default-font-size font-family-regular'
                                               value={nodeData.editValue == t("Untitled") ? '' : (nodeData.editValue || '')}
                                               style={{
                                                   color: "var(--text-color-dark-color)",
                                                   marginLeft: '6px',
                                                   paddingLeft: '0px',
                                                   marginBottom: '0px',
                                                   flexGrow: 1,
                                                   paddingTop: '6px',
                                               }}
                                               variant={"borderless"}
                                               autoFocus={true}
                                            // onKeyPress={(e)=>onCanvasKeyPress(e,nodeData.key)}
                                            //    onChange={(e)=>onChange(e,nodeData.key)}
                                            //    onBlur={(e)=>onBlur(e,nodeData.key)}
                                        />
                                        {/*<div style={{width:'16px',height:'16px',marginLeft:'16px'}}></div>*/}
                                    </div>
                                )
                            } else {
                                return (
                                    <Dropdown overlayClassName='default-dropdown-style' menu={{items:getMenus(nodeData)}} trigger={['contextMenu']} overlayStyle={{width:'auto'}} onOpenChange={(open)=>{
                                        if (open) {
                                            //转到
                                            // props.onAction('zoomTo',{element:nodeData.element})
                                        }
                                    }}>
                                        <div className='flex-row-vertical-center' id={nodeData.key} style={{display:"flex",width:"auto",alignItems:"center",paddingRight:'8px'}}>
                                    <span className={'flex-center img-16'}>
                                        {getElementIcon(nodeData.element,nodeData.color,true)}
                                    </span>

                                            <Input className='default-font-size font-family-regular span-single-line'
                                                   readOnly={true} variant={"borderless"}
                                                   bordered={false}
                                                   style={{
                                                       color: isPresentMode ? "white" : ((treeSelectedKeys[0] == nodeData.key) ? "var(--text-color-dark-color)" : "var(--text-color-dark-color)"),
                                                       marginLeft: '6px',
                                                       paddingLeft: '0px',
                                                       cursor: "pointer",
                                                       flexGrow: '1',
                                                       paddingTop: '6px',
                                                       marginBottom: '0px',
                                                       paddingRight: '8px',
                                                   }} value={nodeData.title}/>

                                            {
                                                hoveredKey == nodeData.key?
                                                    <div className={'flex-row-vertical-center'}>
                                                        {
                                                            (isNoteElement(nodeData.element) || isPdfFileElement(nodeData.element) || isFileVideoElement(nodeData.element) || isLiveVideoElement(nodeData.element)) &&
                                                            <img className={'img-16 mr-6'} src={getImagePathWithThemeSvg('content_open')} onClick={(event)=>{
                                                                if (event.ctrlKey || event.metaKey) {
                                                                    global.g_isCtrlPressed = true;
                                                                    setTimeout(()=>{
                                                                        global.g_isCtrlPressed = false;
                                                                    },2000);
                                                                }
                                                                // props.onAction('openElement', {element:nodeData.element});
                                                                postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:nodeData.element.customData?.generationData?.id,deeplink:{}});
                                                            }}/>
                                                        }
                                                        <Dropdown menu={{
                                                            items: getMenus(nodeData),
                                                        }} trigger={['click']} align={{offset: [26, -26]}} onOpenChange={(e)=>{
                                                            if (e) {
                                                                // mRightData.current = {node:nodeData};
                                                            }
                                                        }}>
                                                            <div className={'flex-center'} style={{
                                                                height: '100%',
                                                                width: '26px',
                                                                flexShrink: '0',
                                                                marginRight: '0px',
                                                            }} onClick={(event)=>{
                                                                event.stopPropagation();
                                                            }}>
                                                                <img className='img-medium-small'
                                                                     style={{flexShrink: '0',opacity:(hoveredKey == nodeData.key)?'1':'0'}}
                                                                     src={getImagePathWithTheme("horizontal_content_more.svg")} />
                                                            </div>
                                                        </Dropdown>
                                                    </div> :<>
                                                        {
                                                            nodeData.annoCount > 0 &&
                                                            <span className={'flex-center'} style={{
                                                                background:'var(--content-anno-count-background)',
                                                                borderRadius:'10px',
                                                                height:'20px',
                                                                minWidth:'20px',
                                                                fontSize:'10px',
                                                                color:'var(--text-color)'
                                                            }}>{nodeData.annoCount}</span>
                                                        }
                                                    </>
                                            }
                                        </div>
                                    </Dropdown>
                                )
                            }
                        }}
                    />
                </ConfigProvider>
        }
    </>
})

export default TreeListContentBookmark;